import React from 'react'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { InputAdornment } from '@material-ui/core'
import DateFnsUtils from '@date-io/date-fns'
import Downarrow from '../../../assetss/img/Downarrow.svg'
import './index.scss'

const DateInput = ({ date, setDate }) => {
  return (
    <div className='wrapperDateInput'>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <DatePicker
          required
          minDate={new Date()}
          disablePast
          autoOk
          variant='inline'
          inputVariant='outlined'
          format='MM/dd/yyyy'
          value={date}
          InputAdornmentProps={{ position: 'end' }}
          onChange={date => setDate(new Date(date))}
          InputProps={{ endAdornment: (<InputAdornment position='end'><img src={Downarrow} /></InputAdornment>) }}
        />
      </MuiPickersUtilsProvider>
    </div>
  )
}

export default DateInput
